const reportfc = [{
  desc: '险别占比分析',
  options: {
    url: '/reportfc/insTypeAnalysisReportQuery',
    method: 'post'
  }
}, {
  desc: '险别占比分析 - 导出',
  options: {
    url: '/reportfc/insTypeAnalysisReportQueryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '分支机构分析',
  options: {
    url: '/reportfc/branchOrgAnalysisReportQuery',
    method: 'post'
  }
}, {
  desc: '分支机构分析 - 导出',
  options: {
    url: '/reportfc/branchOrgAnalysisReportQueryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '业务来源分析',
  options: {
    url: '/reportfc/branchTypeAnalysisReportQuery',
    method: 'post'
  }
}, {
  desc: '业务来源分析 - 导出',
  options: {
    url: '/reportfc/branchTypeAnalysisReportQueryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '区域占比分析',
  options: {
    url: '/reportfc/regionAnalysisReportQuery',
    method: 'post'
  }
}, {
  desc: '区域占比分析 - 导出',
  options: {
    url: '/reportfc/regionAnalysisReportQueryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '保险公司分析',
  options: {
    url: '/reportfc/supplierAnalysisReportQuery',
    method: 'post'
  }
}, {
  desc: '保险公司分析 - 导出',
  options: {
    url: '/reportfc/supplierAnalysisReportQueryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}]
export default reportfc



// WEBPACK FOOTER //
// ./src/api/reportfc.js